import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ap-logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-00395d7e")

_pushScopeId("data-v-00395d7e")
const _hoisted_1 = {
  key: 0,
  class: "top-nav"
}
const _hoisted_2 = { class: "very-top" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    style: {"max-width":"400px","padding":"20px"},
    alt: "AccidentPlan Logo"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OrgSelect = _resolveComponent("OrgSelect")
  const _component_DefaultNavbar = _resolveComponent("DefaultNavbar")

  return ((_ctx.$route.meta.print||false) === false)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.isVAR || _ctx.isSuperAdmin)
            ? (_openBlock(), _createBlock(_component_OrgSelect, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_DefaultNavbar)
      ]))
    : _createCommentVNode("", true)
})